import React, { useState, useRef } from "react";
import TableRows from "./TableRow";
function AddDeleteTableRows({
  itemType,
  ply,
  printdesc,
  calculationtype,
  unitsize,
  challannol,
  data,
  add,
  edit,
  deleter,
  plyquantity,
  Unit,
  sqmt,
  UnitSize,
  SheetLDesc,
  CustomerId,
  ChallanNoL,
  Code,
  sheetldesc,
  CodeArray,
  onSheetLDescRefsReady,
}) {
  const [rowsData, setRowsData] = useState([]);
  const sheetLDescRefs = useRef([]);

  const addTableRows = () => {
    const rowsInput = {
      UnitSize: 3,
      SheetLDesc: "",
      SqMt: "",
      ChallanNoL: "",
      CodeNo: "",
      ItemType: "",
      DescriptionL: "",
      Ply: "",
      Length: "",
      LengthSoot: "",
      Width: "",
      WidthSoot: "",
      Height: "",
      HeightSoot: "",
      CalculationType: "",
      Qty: "",
      RmgQty: "",
      Rate: "",
      PrintDesc: "",
      PrintRate: "",
      Amount: "",
      MainRate: "",
      CalRate: "",
    };
    Array.prototype.push.apply(rowsData, data);

    setRowsData([...rowsData, rowsInput]);
    console.log(rowsData);
  };

  const controls = useRef([]);

  const handler = (index, evnt) => {
    if (evnt.key == "Enter") {
      const next = controls.current[index + "itemtype"];
      next.focus();

      evnt.preventDefault();
    }
  };

  const deleteTableRows = index => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
  };

  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;

    const rowsInput = [...data];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);


    var MainRate = 0;

    //LengthSoot

    if (name == "LengthSoot") {
      var LengthSoot = evnt.target.value;

      if (LengthSoot == 1) rowsInput[index]["LengthSoot"] = "1/8";
      else if (LengthSoot == 2) rowsInput[index]["LengthSoot"] = "1/4";
      else if (LengthSoot == 3) rowsInput[index]["LengthSoot"] = "3/8";
      else if (LengthSoot == 4) rowsInput[index]["LengthSoot"] = "1/2";
      else if (LengthSoot == 5) rowsInput[index]["LengthSoot"] = "5/8";
      else if (LengthSoot == 6) rowsInput[index]["LengthSoot"] = "3/4";
      else if (LengthSoot == 7) rowsInput[index]["LengthSoot"] = "7/8";

      if (rowsInput[index]["CalculationType"] != "") {
        var Length = rowsInput[index]["Length"];
        var Height = rowsInput[index]["Height"];
        var Width = rowsInput[index]["Width"];

        var LengthSoot = rowsInput[index]["LengthSoot"];
        var HeightSoot = rowsInput[index]["HeightSoot"];
        var WidthSoot = rowsInput[index]["WidthSoot"];

        if (LengthSoot == "1/8") LengthSoot = 0.125;
        else if (LengthSoot == "1/4") LengthSoot = 0.25;
        else if (LengthSoot == "3/8") LengthSoot = 0.375;
        else if (LengthSoot == "1/2") LengthSoot = 0.5;
        else if (LengthSoot == "5/8") LengthSoot = 0.625;
        else if (LengthSoot == "3/4") LengthSoot = 0.75;
        else if (LengthSoot == "7/8") LengthSoot = 0.875;
        else LengthSoot = 0;

        if (HeightSoot == "1/8") HeightSoot = 0.125;
        else if (HeightSoot == "1/4") HeightSoot = 0.25;
        else if (HeightSoot == "3/8") HeightSoot = 0.375;
        else if (HeightSoot == "1/2") HeightSoot = 0.5;
        else if (HeightSoot == "5/8") HeightSoot = 0.625;
        else if (HeightSoot == "3/4") HeightSoot = 0.75;
        else if (HeightSoot == "7/8") HeightSoot = 0.875;
        else HeightSoot = 0;

        if (WidthSoot == "1/8") WidthSoot = 0.125;
        else if (WidthSoot == "1/4") WidthSoot = 0.25;
        else if (WidthSoot == "3/8") WidthSoot = 0.375;
        else if (WidthSoot == "1/2") WidthSoot = 0.5;
        else if (WidthSoot == "5/8") WidthSoot = 0.625;
        else if (WidthSoot == "3/4") WidthSoot = 0.75;
        else if (WidthSoot == "7/8") WidthSoot = 0.875;
        else WidthSoot = 0;

        var cal = rowsInput[index]["CalculationType"];

        var Safai = 0;

        if (cal == 1) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(Width) +
              2 +
              parseFloat(LengthSoot) +
              parseFloat(WidthSoot)) *
              2 *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Safai))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];
          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 3) {
          var Rate =
            ((parseFloat(Height) +
              parseFloat(Length) +
              parseFloat(Height) +
              parseFloat(HeightSoot) +
              parseFloat(HeightSoot) +
              parseFloat(LengthSoot)) *
              (parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(HeightSoot) +
                parseFloat(Height))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 5) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 6) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              ((parseFloat(Width) + parseFloat(WidthSoot)) / 2 +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          rowsInput[index]["Rate"] = Rate;
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 7) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }

          rowsInput[index]["CalRate"] = Rate;
        }

        if (rowsInput[index]["Qty"] != "") {
          var Rate = rowsInput[index]["Rate"];

          var Qty = rowsInput[index]["Qty"];

          var Amount = parseFloat(Rate) * parseFloat(Qty);

          Amount = parseFloat(Amount).toFixed(2);

          rowsInput[index]["Amount"] = Amount;
        }
      }
    }

    //widthSoot
    if (name == "WidthSoot") {
      var LengthSoot = evnt.target.value;

      if (LengthSoot == 1) rowsInput[index]["WidthSoot"] = "1/8";
      else if (LengthSoot == 2) rowsInput[index]["WidthSoot"] = "1/4";
      else if (LengthSoot == 3) rowsInput[index]["WidthSoot"] = "3/8";
      else if (LengthSoot == 4) rowsInput[index]["WidthSoot"] = "1/2";
      else if (LengthSoot == 5) rowsInput[index]["WidthSoot"] = "5/8";
      else if (LengthSoot == 6) rowsInput[index]["WidthSoot"] = "3/4";
      else if (LengthSoot == 7) rowsInput[index]["WidthSoot"] = "7/8";

      if (rowsInput[index]["CalculationType"] != "") {
        var Length = rowsInput[index]["Length"];
        var Height = rowsInput[index]["Height"];
        var Width = rowsInput[index]["Width"];

        var LengthSoot = rowsInput[index]["LengthSoot"];
        var HeightSoot = rowsInput[index]["HeightSoot"];
        var WidthSoot = rowsInput[index]["WidthSoot"];

        if (LengthSoot == "1/8") LengthSoot = 0.125;
        else if (LengthSoot == "1/4") LengthSoot = 0.25;
        else if (LengthSoot == "3/8") LengthSoot = 0.375;
        else if (LengthSoot == "1/2") LengthSoot = 0.5;
        else if (LengthSoot == "5/8") LengthSoot = 0.625;
        else if (LengthSoot == "3/4") LengthSoot = 0.75;
        else if (LengthSoot == "7/8") LengthSoot = 0.875;
        else LengthSoot = 0;

        if (HeightSoot == "1/8") HeightSoot = 0.125;
        else if (HeightSoot == "1/4") HeightSoot = 0.25;
        else if (HeightSoot == "3/8") HeightSoot = 0.375;
        else if (HeightSoot == "1/2") HeightSoot = 0.5;
        else if (HeightSoot == "5/8") HeightSoot = 0.625;
        else if (HeightSoot == "3/4") HeightSoot = 0.75;
        else if (HeightSoot == "7/8") HeightSoot = 0.875;
        else HeightSoot = 0;

        if (WidthSoot == "1/8") WidthSoot = 0.125;
        else if (WidthSoot == "1/4") WidthSoot = 0.25;
        else if (WidthSoot == "3/8") WidthSoot = 0.375;
        else if (WidthSoot == "1/2") WidthSoot = 0.5;
        else if (WidthSoot == "5/8") WidthSoot = 0.625;
        else if (WidthSoot == "3/4") WidthSoot = 0.75;
        else if (WidthSoot == "7/8") WidthSoot = 0.875;
        else WidthSoot = 0;

        var cal = rowsInput[index]["CalculationType"];

        var Safai = 0;

        if (cal == 1) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(Width) +
              2 +
              parseFloat(LengthSoot) +
              parseFloat(WidthSoot)) *
              2 *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Safai))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];
          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 3) {
          var Rate =
            ((parseFloat(Height) +
              parseFloat(Length) +
              parseFloat(Height) +
              parseFloat(HeightSoot) +
              parseFloat(HeightSoot) +
              parseFloat(LengthSoot)) *
              (parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(HeightSoot) +
                parseFloat(Height))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 5) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 6) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              ((parseFloat(Width) + parseFloat(WidthSoot)) / 2 +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 7) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        }

        if (rowsInput[index]["Qty"] != "") {
          var Rate = rowsInput[index]["Rate"];

          var Qty = rowsInput[index]["Qty"];

          var Amount = parseFloat(Rate) * parseFloat(Qty);

          Amount = parseFloat(Amount).toFixed(2);

          rowsInput[index]["Amount"] = Amount;
        }

      }
    }

    //HeightSoot

    if (name == "HeightSoot") {
      var LengthSoot = evnt.target.value;

      if (LengthSoot == 1) rowsInput[index]["HeightSoot"] = "1/8";
      else if (LengthSoot == 2) rowsInput[index]["HeightSoot"] = "1/4";
      else if (LengthSoot == 3) rowsInput[index]["HeightSoot"] = "3/8";
      else if (LengthSoot == 4) rowsInput[index]["HeightSoot"] = "1/2";
      else if (LengthSoot == 5) rowsInput[index]["HeightSoot"] = "5/8";
      else if (LengthSoot == 6) rowsInput[index]["HeightSoot"] = "3/4";
      else if (LengthSoot == 7) rowsInput[index]["HeightSoot"] = "7/8";

      if (rowsInput[index]["CalculationType"] != "") {
        var Length = rowsInput[index]["Length"];
        var Height = rowsInput[index]["Height"];
        var Width = rowsInput[index]["Width"];

        var LengthSoot = rowsInput[index]["LengthSoot"];
        var HeightSoot = rowsInput[index]["HeightSoot"];
        var WidthSoot = rowsInput[index]["WidthSoot"];

        if (LengthSoot == "1/8") LengthSoot = 0.125;
        else if (LengthSoot == "1/4") LengthSoot = 0.25;
        else if (LengthSoot == "3/8") LengthSoot = 0.375;
        else if (LengthSoot == "1/2") LengthSoot = 0.5;
        else if (LengthSoot == "5/8") LengthSoot = 0.625;
        else if (LengthSoot == "3/4") LengthSoot = 0.75;
        else if (LengthSoot == "7/8") LengthSoot = 0.875;
        else LengthSoot = 0;

        if (HeightSoot == "1/8") HeightSoot = 0.125;
        else if (HeightSoot == "1/4") HeightSoot = 0.25;
        else if (HeightSoot == "3/8") HeightSoot = 0.375;
        else if (HeightSoot == "1/2") HeightSoot = 0.5;
        else if (HeightSoot == "5/8") HeightSoot = 0.625;
        else if (HeightSoot == "3/4") HeightSoot = 0.75;
        else if (HeightSoot == "7/8") HeightSoot = 0.875;
        else HeightSoot = 0;

        if (WidthSoot == "1/8") WidthSoot = 0.125;
        else if (WidthSoot == "1/4") WidthSoot = 0.25;
        else if (WidthSoot == "3/8") WidthSoot = 0.375;
        else if (WidthSoot == "1/2") WidthSoot = 0.5;
        else if (WidthSoot == "5/8") WidthSoot = 0.625;
        else if (WidthSoot == "3/4") WidthSoot = 0.75;
        else if (WidthSoot == "7/8") WidthSoot = 0.875;
        else WidthSoot = 0;

        var cal = rowsInput[index]["CalculationType"];

        var Safai = 0;

        if (cal == 1) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(Width) +
              2 +
              parseFloat(LengthSoot) +
              parseFloat(WidthSoot)) *
              2 *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Safai))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];
          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 3) {
          var Rate =
            ((parseFloat(Height) +
              parseFloat(Length) +
              parseFloat(Height) +
              parseFloat(HeightSoot) +
              parseFloat(HeightSoot) +
              parseFloat(LengthSoot)) *
              (parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(HeightSoot) +
                parseFloat(Height))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 5) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 6) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              ((parseFloat(Width) + parseFloat(WidthSoot)) / 2 +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 7) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        }

        if (rowsInput[index]["Qty"] != "") {
          var Rate = rowsInput[index]["Rate"];

          var Qty = rowsInput[index]["Qty"];

          var Amount = parseFloat(Rate) * parseFloat(Qty);

          Amount = parseFloat(Amount).toFixed(2);

          rowsInput[index]["Amount"] = Amount;
        }
      }
    }

    //PrintDesc

    if (name == "PrintDesc") {
      const index1 = evnt.target.selectedIndex;
      const el = evnt.target.childNodes[index1];
      const option = el.getAttribute("id");

      const rowsInput = [...rowsData];
      var PrevRate = 0;
      var NewRate = 0;

      if (option == null || option == "null" || option == "") {
        var LastPrintRate = rowsInput[index]["PrintRate"];
        PrevRate = rowsInput[index]["Rate"];
        NewRate = parseFloat(PrevRate) - parseFloat(LastPrintRate);
        rowsInput[index]["Rate"] = NewRate;
        rowsInput[index]["PrintRate"] = 0;
      } else {
        if (rowsInput[index]["CalRate"] == "") {
          PrevRate = rowsInput[index]["Rate"];
        } else {
          PrevRate = rowsInput[index]["CalRate"];
        }

        NewRate = parseFloat(option) + parseFloat(PrevRate);
        rowsInput[index]["Rate"] = NewRate;

        rowsInput[index]["PrintRate"] = option;
      }

      if (rowsInput[index]["Qty"] != "") {
        var Rate = rowsInput[index]["Rate"];

        var Qty = rowsInput[index]["Qty"];

        var Amount = parseFloat(Rate) * parseFloat(Qty);

        Amount = parseFloat(Amount).toFixed(2);

        rowsInput[index]["Amount"] = Amount;
      }
    }

    //Ply

    if (name == "Ply") {
      const index1 = evnt.target.selectedIndex;
      const el = evnt.target.childNodes[index1];
      const option = el.getAttribute("id");

      const rowsInput = [...rowsData];
      rowsInput[index]["MainRate"] = option;
      rowsInput[index]["Rate"] = option;

      if (rowsInput[index]["Length"] != "") {
        var Length = rowsInput[index]["Length"];
        var Height = rowsInput[index]["Height"];
        var Width = rowsInput[index]["Width"];

        var LengthSoot = rowsInput[index]["LengthSoot"];
        var HeightSoot = rowsInput[index]["HeightSoot"];
        var WidthSoot = rowsInput[index]["WidthSoot"];

        if (LengthSoot == "1/8") LengthSoot = 0.125;
        else if (LengthSoot == "1/4") LengthSoot = 0.25;
        else if (LengthSoot == "3/8") LengthSoot = 0.375;
        else if (LengthSoot == "1/2") LengthSoot = 0.5;
        else if (LengthSoot == "5/8") LengthSoot = 0.625;
        else if (LengthSoot == "3/4") LengthSoot = 0.75;
        else if (LengthSoot == "7/8") LengthSoot = 0.875;
        else LengthSoot = 0;

        if (HeightSoot == "1/8") HeightSoot = 0.125;
        else if (HeightSoot == "1/4") HeightSoot = 0.25;
        else if (HeightSoot == "3/8") HeightSoot = 0.375;
        else if (HeightSoot == "1/2") HeightSoot = 0.5;
        else if (HeightSoot == "5/8") HeightSoot = 0.625;
        else if (HeightSoot == "3/4") HeightSoot = 0.75;
        else if (HeightSoot == "7/8") HeightSoot = 0.875;
        else HeightSoot = 0;

        if (WidthSoot == "1/8") WidthSoot = 0.125;
        else if (WidthSoot == "1/4") WidthSoot = 0.25;
        else if (WidthSoot == "3/8") WidthSoot = 0.375;
        else if (WidthSoot == "1/2") WidthSoot = 0.5;
        else if (WidthSoot == "5/8") WidthSoot = 0.625;
        else if (WidthSoot == "3/4") WidthSoot = 0.75;
        else if (WidthSoot == "7/8") WidthSoot = 0.875;
        else WidthSoot = 0;

        var cal = rowsInput[index]["CalculationType"];

        var Safai = 0;

        if (cal == 1) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(Width) +
              2 +
              parseFloat(LengthSoot) +
              parseFloat(WidthSoot)) *
              2 *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Safai))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];
          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 3) {
          var Rate =
            ((parseFloat(Height) +
              parseFloat(Length) +
              parseFloat(Height) +
              parseFloat(HeightSoot) +
              parseFloat(HeightSoot) +
              parseFloat(LengthSoot)) *
              (parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(HeightSoot) +
                parseFloat(Height))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 5) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 6) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              ((parseFloat(Width) + parseFloat(WidthSoot)) / 2 +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 7) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        }

        if (rowsInput[index]["Qty"] != "") {
          var Rate = rowsInput[index]["Rate"];

          var Qty = rowsInput[index]["Qty"];

          var Amount = parseFloat(Rate) * parseFloat(Qty);

          Amount = parseFloat(Amount).toFixed(2);

          rowsInput[index]["Amount"] = Amount;
        }
      }
    }

    //Length

    if (name == "Length") {
      if (rowsInput[index]["CalculationType"] != "") {
        var Length = rowsInput[index]["Length"];
        var Height = rowsInput[index]["Height"];
        var Width = rowsInput[index]["Width"];

        var LengthSoot = rowsInput[index]["LengthSoot"];
        var HeightSoot = rowsInput[index]["HeightSoot"];
        var WidthSoot = rowsInput[index]["WidthSoot"];

        if (LengthSoot == "1/8") LengthSoot = 0.125;
        else if (LengthSoot == "1/4") LengthSoot = 0.25;
        else if (LengthSoot == "3/8") LengthSoot = 0.375;
        else if (LengthSoot == "1/2") LengthSoot = 0.5;
        else if (LengthSoot == "5/8") LengthSoot = 0.625;
        else if (LengthSoot == "3/4") LengthSoot = 0.75;
        else if (LengthSoot == "7/8") LengthSoot = 0.875;
        else LengthSoot = 0;

        if (HeightSoot == "1/8") HeightSoot = 0.125;
        else if (HeightSoot == "1/4") HeightSoot = 0.25;
        else if (HeightSoot == "3/8") HeightSoot = 0.375;
        else if (HeightSoot == "1/2") HeightSoot = 0.5;
        else if (HeightSoot == "5/8") HeightSoot = 0.625;
        else if (HeightSoot == "3/4") HeightSoot = 0.75;
        else if (HeightSoot == "7/8") HeightSoot = 0.875;
        else HeightSoot = 0;

        if (WidthSoot == "1/8") WidthSoot = 0.125;
        else if (WidthSoot == "1/4") WidthSoot = 0.25;
        else if (WidthSoot == "3/8") WidthSoot = 0.375;
        else if (WidthSoot == "1/2") WidthSoot = 0.5;
        else if (WidthSoot == "5/8") WidthSoot = 0.625;
        else if (WidthSoot == "3/4") WidthSoot = 0.75;
        else if (WidthSoot == "7/8") WidthSoot = 0.875;
        else WidthSoot = 0;

        var cal = rowsInput[index]["CalculationType"];

        var Safai = 0;

        if (cal == 1) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(Width) +
              2 +
              parseFloat(LengthSoot) +
              parseFloat(WidthSoot)) *
              2 *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Safai))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];
          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 3) {
          var Rate =
            ((parseFloat(Height) +
              parseFloat(Length) +
              parseFloat(Height) +
              parseFloat(HeightSoot) +
              parseFloat(HeightSoot) +
              parseFloat(LengthSoot)) *
              (parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(HeightSoot) +
                parseFloat(Height))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 5) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 6) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              ((parseFloat(Width) + parseFloat(WidthSoot)) / 2 +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 7) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        }
      }

      if (rowsInput[index]["Qty"] != "") {
        var Rate = rowsInput[index]["Rate"];

        var Qty = rowsInput[index]["Qty"];

        var Amount = parseFloat(Rate) * parseFloat(Qty);

        Amount = parseFloat(Amount).toFixed(2);

        rowsInput[index]["Amount"] = Amount;
      }
    }

    //Height

    if (name == "Height") {
      if (rowsInput[index]["CalculationType"] != "") {
        var Length = rowsInput[index]["Length"];
        var Height = rowsInput[index]["Height"];
        var Width = rowsInput[index]["Width"];

        var LengthSoot = rowsInput[index]["LengthSoot"];
        var HeightSoot = rowsInput[index]["HeightSoot"];
        var WidthSoot = rowsInput[index]["WidthSoot"];

        if (LengthSoot == "1/8") LengthSoot = 0.125;
        else if (LengthSoot == "1/4") LengthSoot = 0.25;
        else if (LengthSoot == "3/8") LengthSoot = 0.375;
        else if (LengthSoot == "1/2") LengthSoot = 0.5;
        else if (LengthSoot == "5/8") LengthSoot = 0.625;
        else if (LengthSoot == "3/4") LengthSoot = 0.75;
        else if (LengthSoot == "7/8") LengthSoot = 0.875;
        else LengthSoot = 0;

        if (HeightSoot == "1/8") HeightSoot = 0.125;
        else if (HeightSoot == "1/4") HeightSoot = 0.25;
        else if (HeightSoot == "3/8") HeightSoot = 0.375;
        else if (HeightSoot == "1/2") HeightSoot = 0.5;
        else if (HeightSoot == "5/8") HeightSoot = 0.625;
        else if (HeightSoot == "3/4") HeightSoot = 0.75;
        else if (HeightSoot == "7/8") HeightSoot = 0.875;
        else HeightSoot = 0;

        if (WidthSoot == "1/8") WidthSoot = 0.125;
        else if (WidthSoot == "1/4") WidthSoot = 0.25;
        else if (WidthSoot == "3/8") WidthSoot = 0.375;
        else if (WidthSoot == "1/2") WidthSoot = 0.5;
        else if (WidthSoot == "5/8") WidthSoot = 0.625;
        else if (WidthSoot == "3/4") WidthSoot = 0.75;
        else if (WidthSoot == "7/8") WidthSoot = 0.875;
        else WidthSoot = 0;
        console.log(WidthSoot);

        var cal = rowsInput[index]["CalculationType"];

        var Safai = 0;

        if (cal == 1) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(Width) +
              2 +
              parseFloat(LengthSoot) +
              parseFloat(WidthSoot)) *
              2 *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Safai))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];
          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 3) {
          var Rate =
            ((parseFloat(Height) +
              parseFloat(Length) +
              parseFloat(Height) +
              parseFloat(HeightSoot) +
              parseFloat(HeightSoot) +
              parseFloat(LengthSoot)) *
              (parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(HeightSoot) +
                parseFloat(Height))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 5) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          console.log(PrevRate);

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 6) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              ((parseFloat(Width) + parseFloat(WidthSoot)) / 2 +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 7) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        }
      }

      if (rowsInput[index]["Qty"] != "") {
        var Rate = rowsInput[index]["Rate"];

        var Qty = rowsInput[index]["Qty"];

        var Amount = parseFloat(Rate) * parseFloat(Qty);

        Amount = parseFloat(Amount).toFixed(2);

        rowsInput[index]["Amount"] = Amount;
      }
    }

    //Width

    if (name == "Width") {
      if (rowsInput[index]["CalculationType"] != "") {
        var Length = rowsInput[index]["Length"];
        var Height = rowsInput[index]["Height"];
        var Width = rowsInput[index]["Width"];

        var LengthSoot = rowsInput[index]["LengthSoot"];
        var HeightSoot = rowsInput[index]["HeightSoot"];
        var WidthSoot = rowsInput[index]["WidthSoot"];

        if (LengthSoot == "1/8") LengthSoot = 0.125;
        else if (LengthSoot == "1/4") LengthSoot = 0.25;
        else if (LengthSoot == "3/8") LengthSoot = 0.375;
        else if (LengthSoot == "1/2") LengthSoot = 0.5;
        else if (LengthSoot == "5/8") LengthSoot = 0.625;
        else if (LengthSoot == "3/4") LengthSoot = 0.75;
        else if (LengthSoot == "7/8") LengthSoot = 0.875;
        else LengthSoot = 0;

        if (HeightSoot == "1/8") HeightSoot = 0.125;
        else if (HeightSoot == "1/4") HeightSoot = 0.25;
        else if (HeightSoot == "3/8") HeightSoot = 0.375;
        else if (HeightSoot == "1/2") HeightSoot = 0.5;
        else if (HeightSoot == "5/8") HeightSoot = 0.625;
        else if (HeightSoot == "3/4") HeightSoot = 0.75;
        else if (HeightSoot == "7/8") HeightSoot = 0.875;
        else HeightSoot = 0;

        if (WidthSoot == "1/8") WidthSoot = 0.125;
        else if (WidthSoot == "1/4") WidthSoot = 0.25;
        else if (WidthSoot == "3/8") WidthSoot = 0.375;
        else if (WidthSoot == "1/2") WidthSoot = 0.5;
        else if (WidthSoot == "5/8") WidthSoot = 0.625;
        else if (WidthSoot == "3/4") WidthSoot = 0.75;
        else if (WidthSoot == "7/8") WidthSoot = 0.875;
        else WidthSoot = 0;

        var cal = rowsInput[index]["CalculationType"];

        var Safai = 0;

        if (cal == 1) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(Width) +
              2 +
              parseFloat(LengthSoot) +
              parseFloat(WidthSoot)) *
              2 *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Safai))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];
          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 3) {
          var Rate =
            ((parseFloat(Height) +
              parseFloat(Length) +
              parseFloat(Height) +
              parseFloat(HeightSoot) +
              parseFloat(HeightSoot) +
              parseFloat(LengthSoot)) *
              (parseFloat(Height) +
                parseFloat(HeightSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(HeightSoot) +
                parseFloat(Height))) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 5) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 6) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              ((parseFloat(Width) + parseFloat(WidthSoot)) / 2 +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        } else if (cal == 7) {
          var Rate =
            ((parseFloat(Length) +
              parseFloat(LengthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              2) *
              (parseFloat(Width) +
                parseFloat(WidthSoot) +
                parseFloat(Height) +
                parseFloat(HeightSoot)) *
              2) /
            1550;

          var PrevRate = rowsInput[index]["MainRate"];

          Rate = parseFloat(Rate) * parseFloat(PrevRate);

          Rate = parseFloat(Rate).toFixed(2);

          if (rowsInput[index]["PrintRate"] != "") {
            var PrintRate = rowsInput[index]["PrintRate"];
            Rate = parseFloat(Rate) + parseFloat(PrintRate);
            rowsInput[index]["Rate"] = Rate;
          } else {
            rowsInput[index]["Rate"] = Rate;
          }
          rowsInput[index]["CalRate"] = Rate;
        }
      }

      if (rowsInput[index]["Qty"] != "") {
        var Rate = rowsInput[index]["Rate"];

        var Qty = rowsInput[index]["Qty"];

        var Amount = parseFloat(Rate) * parseFloat(Qty);

        Amount = parseFloat(Amount).toFixed(2);

        rowsInput[index]["Amount"] = Amount;
      }
    }

    //CalculationType

    if (name == "CalculationType") {
      //SimpleBox

      var Length = rowsInput[index]["Length"];
      var Height = rowsInput[index]["Height"];
      var Width = rowsInput[index]["Width"];

      var LengthSoot = rowsInput[index]["LengthSoot"];
      var HeightSoot = rowsInput[index]["HeightSoot"];
      var WidthSoot = rowsInput[index]["WidthSoot"];

      if (LengthSoot == "1/8") LengthSoot = 0.125;
      else if (LengthSoot == "1/4") LengthSoot = 0.25;
      else if (LengthSoot == "3/8") LengthSoot = 0.375;
      else if (LengthSoot == "1/2") LengthSoot = 0.5;
      else if (LengthSoot == "5/8") LengthSoot = 0.625;
      else if (LengthSoot == "3/4") LengthSoot = 0.75;
      else if (LengthSoot == "7/8") LengthSoot = 0.875;
      else LengthSoot = 0;

      if (HeightSoot == "1/8") HeightSoot = 0.125;
      else if (HeightSoot == "1/4") HeightSoot = 0.25;
      else if (HeightSoot == "3/8") HeightSoot = 0.375;
      else if (HeightSoot == "1/2") HeightSoot = 0.5;
      else if (HeightSoot == "5/8") HeightSoot = 0.625;
      else if (HeightSoot == "3/4") HeightSoot = 0.75;
      else if (HeightSoot == "7/8") HeightSoot = 0.875;
      else HeightSoot = 0;

      if (WidthSoot == "1/8") WidthSoot = 0.125;
      else if (WidthSoot == "1/4") WidthSoot = 0.25;
      else if (WidthSoot == "3/8") WidthSoot = 0.375;
      else if (WidthSoot == "1/2") WidthSoot = 0.5;
      else if (WidthSoot == "5/8") WidthSoot = 0.625;
      else if (WidthSoot == "3/4") WidthSoot = 0.75;
      else if (WidthSoot == "7/8") WidthSoot = 0.875;
      else WidthSoot = 0;

      var Safai = 0;

      const index1 = evnt.target.selectedIndex;
      const el = evnt.target.childNodes[index1];
      const Id = el.getAttribute("id");

      if (evnt.target.value == 1) {
        var Rate =
          ((parseFloat(Length) +
            parseFloat(Width) +
            2 +
            parseFloat(LengthSoot) +
            parseFloat(WidthSoot)) *
            2 *
            (parseFloat(Width) +
              parseFloat(WidthSoot) +
              parseFloat(Height) +
              parseFloat(HeightSoot) +
              parseFloat(Safai))) /
          1550;

        var PrevRate = rowsInput[index]["MainRate"];
        Rate = parseFloat(Rate) * parseFloat(PrevRate);

        Rate = parseFloat(Rate).toFixed(2);

        if (rowsInput[index]["PrintRate"] != "") {
          var PrintRate = rowsInput[index]["PrintRate"];
          Rate = parseFloat(Rate) + parseFloat(PrintRate);
          rowsInput[index]["Rate"] = Rate;
        } else {
          rowsInput[index]["Rate"] = Rate;
        }

        rowsInput[index]["CalRate"] = Rate;
      } else if (evnt.target.value == 3) {
        var Rate =
          ((parseFloat(Height) +
            parseFloat(Length) +
            parseFloat(Height) +
            parseFloat(HeightSoot) +
            parseFloat(HeightSoot) +
            parseFloat(LengthSoot)) *
            (parseFloat(Height) +
              parseFloat(HeightSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              parseFloat(HeightSoot) +
              parseFloat(Height))) /
          1550;

        var PrevRate = rowsInput[index]["MainRate"];

        Rate = parseFloat(Rate) * parseFloat(PrevRate);

        Rate = parseFloat(Rate).toFixed(2);

        if (rowsInput[index]["PrintRate"] != "") {
          var PrintRate = rowsInput[index]["PrintRate"];
          Rate = parseFloat(Rate) + parseFloat(PrintRate);
          rowsInput[index]["Rate"] = Rate;
        } else {
          rowsInput[index]["Rate"] = Rate;
        }
        rowsInput[index]["CalRate"] = Rate;
      } else if (evnt.target.value == 5) {
        var Rate =
          ((parseFloat(Length) +
            parseFloat(LengthSoot) +
            parseFloat(Width) +
            parseFloat(WidthSoot) +
            2) *
            (parseFloat(Width) +
              parseFloat(WidthSoot) +
              parseFloat(Width) +
              parseFloat(WidthSoot) +
              parseFloat(Height) +
              parseFloat(HeightSoot)) *
            2) /
          1550;

        var PrevRate = rowsInput[index]["MainRate"];

        Rate = parseFloat(Rate) * parseFloat(PrevRate);

        Rate = parseFloat(Rate).toFixed(2);

        if (rowsInput[index]["PrintRate"] != "") {
          var PrintRate = rowsInput[index]["PrintRate"];
          Rate = parseFloat(Rate) + parseFloat(PrintRate);
          rowsInput[index]["Rate"] = Rate;
        } else {
          rowsInput[index]["Rate"] = Rate;
        }
        rowsInput[index]["CalRate"] = Rate;
      } else if (evnt.target.value == 6) {
        var Rate =
          ((parseFloat(Length) +
            parseFloat(LengthSoot) +
            parseFloat(Width) +
            parseFloat(WidthSoot) +
            2) *
            ((parseFloat(Width) + parseFloat(WidthSoot)) / 2 +
              parseFloat(Height) +
              parseFloat(HeightSoot)) *
            2) /
          1550;

        var PrevRate = rowsInput[index]["MainRate"];

        Rate = parseFloat(Rate) * parseFloat(PrevRate);

        Rate = parseFloat(Rate).toFixed(2);

        if (rowsInput[index]["PrintRate"] != "") {
          var PrintRate = rowsInput[index]["PrintRate"];
          Rate = parseFloat(Rate) + parseFloat(PrintRate);
          rowsInput[index]["Rate"] = Rate;
        } else {
          rowsInput[index]["Rate"] = Rate;
        }
        rowsInput[index]["CalRate"] = Rate;
      } else if (evnt.target.value == 7) {
        var Rate =
          ((parseFloat(Length) +
            parseFloat(LengthSoot) +
            parseFloat(Width) +
            parseFloat(WidthSoot) +
            2) *
            (parseFloat(Width) +
              parseFloat(WidthSoot) +
              parseFloat(Height) +
              parseFloat(HeightSoot)) *
            2) /
          1550;

        var PrevRate = rowsInput[index]["MainRate"];

        Rate = parseFloat(Rate) * parseFloat(PrevRate);

        Rate = parseFloat(Rate).toFixed(2);

        if (rowsInput[index]["PrintRate"] != "") {
          var PrintRate = rowsInput[index]["PrintRate"];
          Rate = parseFloat(Rate) + parseFloat(PrintRate);
          rowsInput[index]["Rate"] = Rate;
        } else {
          rowsInput[index]["Rate"] = Rate;
        }
        rowsInput[index]["CalRate"] = Rate;
      }

      //     const rowsInput = [...rowsData];

      //   rowsInput[index]["Rate"] = option;
      //   setRowsData(rowsInput);

      if (rowsInput[index]["Qty"] != "") {
        var Rate = rowsInput[index]["Rate"];

        var Qty = rowsInput[index]["Qty"];

        var Amount = parseFloat(Rate) * parseFloat(Qty);

        Amount = parseFloat(Amount).toFixed(2);

        rowsInput[index]["Amount"] = Amount;
      }
    }

    //Quantity

    if (name == "Qty") {
      var Rate = rowsInput[index]["Rate"];

      var Qty = rowsInput[index]["Qty"];

      var Amount = parseFloat(Rate) * parseFloat(Qty);

      Amount = parseFloat(Amount).toFixed(2);

      rowsInput[index]["Amount"] = Amount;
    }
  };

  return (
    <div className="table-responsive">
      <table className="" style={{ padding: "0", marginBottom: "10px" }}>
        <thead>
          <tr>
            <th>Sr.</th>
            <th>Is Dir.</th>
            <th>Select SheetSizing</th>
            <th>Unit Size</th>
            <th>Select Style</th>
            <th>Style</th>
            <th>Item Type</th>
            {CustomerId == 2 ||
            CustomerId == 4 ||
            CustomerId == 5 ||
            CustomerId == 6 ||
            CustomerId == 11 ? (
              <th>DescriptionL</th>
            ) : CustomerId == 9 || CustomerId == 10 ? (
              <th>OC No./ Desc.</th>
            ) : null}
            <th>Ply</th>
            <th>Length</th>
            <th></th>
            <th>Width</th>
            <th></th>
            <th>Height</th>
            <th></th>
            <th>PO No.</th>
            {/* {CustomerId == 0 ? <th>Sq mt</th> : null} */}
            <th>Calculation Type</th>
            <th>Sq mt</th>
            {/* {CustomerId == 0 ? <th>Sq mt</th> : null} */}
            <th>Qty</th>
            {CustomerId == 2 ? <th>Unit</th> : null}
            <th>Rate</th>
            <th>Print Desc</th>
            <th>Prn. Rate</th>
            <th>Amount</th>
            <th>Del</th>
            <th>Add</th>
            {/* <th><button type="button" className="btn btn-outline-success" onClick={addTableRows} >+</button></th> */}
          </tr>
        </thead>
        <tbody>
          <TableRows
            rowsData={data}
            deleteTableRows={deleter}
            handleChange={edit}
            addTableRows={add}
            itemType={itemType}
            unitsize={unitsize}
            sqmt={sqmt}
            challannol={challannol}
            printdesc={printdesc}
            ply={ply}
            calculationtype={calculationtype}
            plyquantity={plyquantity}
            Unit={Unit}
            CustomerId={CustomerId}
            Code={Code}
            sheetldesc={sheetldesc}
            CodeArray={CodeArray}
            sheetLDescRefs={sheetLDescRefs}
            onSheetLDescRefsReady={onSheetLDescRefsReady}
          />
        </tbody>
      </table>
    </div>
  );
}
export default AddDeleteTableRows;
